/**
 * HOG FAQ accordion — one open row at a time within a single section.
 * Does not affect product / filter accordion-custom instances elsewhere.
 */
class HogFaqAccordion extends HTMLElement {
  /** @type {AbortController | null} */
  #controller = null;

  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;

    this.addEventListener('toggle', this.#handleToggle, { capture: true, signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
    this.#controller = null;
  }

  /**
   * @param {Event} event
   */
  #handleToggle = (event) => {
    const target = event.target;
    if (!(target instanceof HTMLDetailsElement) || !target.open) return;
    if (!this.contains(target)) return;

    this.querySelectorAll('details[open]').forEach((details) => {
      if (details !== target && details instanceof HTMLDetailsElement) {
        details.open = false;
      }
    });
  };
}

if (!customElements.get('hog-faq-accordion')) {
  customElements.define('hog-faq-accordion', HogFaqAccordion);
}
